export default __webpack_public_path__ + "static/svg-sprite-0d65f62965b175caaf857e4264b935b7.svg";